import React from 'react'
import "./UserTopBanner.scss";
import { GreyDescription, PrevieWhiteHeading } from '../../GlobalText';
import star from "../../../../Assets/start.png";
import previewlogo from "../../../../Assets/previewlogo.png";
import { UserDetails } from '../UserDetails/UserDetails';
import { IMAGES_URL } from '../../../../Url/Url';
export const UserTopBanner = ( {event_logo, event_banner, closing_date, closing_time, event_name}) => {

  console.log(event_logo, event_banner, closing_date, closing_time, event_name,"aaaa")
  const isEventClosed = new Date() > new Date(closing_date);

      const formatDate = (date) => {
        const suffix = ['st', 'nd', 'rd', 'th'];
        const d = new Date(date);
        const day = d.getDate();
        const dayWithSuffix = day + (suffix[(day % 10) - 1] || suffix[3]);
        const month = d.toLocaleString('default', { month: 'long' });
        const year = d.getFullYear();

        return `${dayWithSuffix} ${month}, ${year}`;
    };


  return (
    <>
      <div className="user_topbanner_main">
        <div className="user_topbanner_top">
          <img src={`${IMAGES_URL}/${event_logo}`} alt="event_preview"/>

          <PrevieWhiteHeading>
           {event_name}
          </PrevieWhiteHeading>

          <UserDetails 
          userDetailsColor="#FFFFFF"/>
        </div>
        <div className="user_topbanner_bg">
        <img src={`${IMAGES_URL}/${event_banner}`} alt="event_preview"/>
        </div>

        <div className="user_topbanner_submit_div">
          <div className="user_topbanner_star_div">
            <div className="user_topbanner_preview_sub">
              <img src={star} alt="star" />
              <GreyDescription style={{ fontWeight: "600" }}>
                Entries Deadline
              </GreyDescription>
            </div>
            <div className="user_topbanner_preview_sub">
              <img src={star} alt="star" />
              <GreyDescription style={{ fontWeight: "600" }}>
              {isEventClosed ? 'Event is closed' : `Event will be closed on ${formatDate(closing_date)}`}
              </GreyDescription>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
